export enum APP_MODE {
  EDIT = "EDIT",
  PUBLISHED = "PUBLISHED",
}
